import type { FC } from 'react';
import { createElement } from 'react';

import type { AdvertisingButtonProps } from '@src/components/AdvertisingButton';
import { AdvertisingButton } from '@src/components/AdvertisingButton';
import { AdvertisingLink } from '@src/components/AdvertisingLink/AdvertisingLink';
import { fullDealCalculatorHasOffersData } from 'entities/FullDeal/config';

type Props = Omit<AdvertisingButtonProps, 'advSub' | 'affSub4'> & {
  as?: 'button' | 'link';
};

/**
 * @todo: Кнопка с захардкоженными данными по оферу "Займы" (наш офер ПС)
 */
export const ToFullDealAdvertisingButton: FC<Props> = ({ children, as, ...props }) =>
  createElement(as === 'link' ? AdvertisingLink : AdvertisingButton, {
    advSub: fullDealCalculatorHasOffersData.advSub,
    affSub4: fullDealCalculatorHasOffersData.affSub4,
    visibleLabel: children,
    ...props,
  });
